/**
 * RN9.1 — locale normalisation for the target-language preselection (story #119).
 *
 * MIC and the translation service do not spell every language the same way, so "is the user's
 * language supported?" (RN9) has to be answered against a normalised code. This lives next to the
 * preselection logic rather than in `translationApi.js`: it is a UI concern about MIC's own locale
 * vocabulary, not part of the network contract with Sun.
 *
 * MIC's runtime locale codes are the resource keys registered in `src/i18n.js` — `es, en, eus, pt,
 * fr, ca, de, lv` — which is what `i18n.language` returns and what `user.userConfiguration
 * .languageCode` stores. Against the service catalogue (`es, en, fr, de, pt, eu, ca, lv`) only
 * Basque actually differs; `pt` already matches (only the *file* is named `pt_PT.json`).
 *
 * Normalising never invents a language: a code with no catalogue equivalent comes back unchanged
 * and the caller leaves the target unselected (S22).
 */
export const MIC_LOCALE_TO_SERVICE_CODE = {
  eus: 'eu'
}

/**
 * @param {string} locale a MIC locale code, e.g. 'eus' or 'pt_PT'
 * @returns {string} the service's ISO code when there is one, otherwise the locale's base code
 */
export const normalizeLocaleToServiceCode = (locale) => {
  if (!locale) return ''

  // Region suffixes ('pt_PT', 'es-ES') carry no meaning for the catalogue, which is base-code only.
  const baseCode = locale.toLowerCase().split(/[-_]/)[0]

  return MIC_LOCALE_TO_SERVICE_CODE[baseCode] ?? baseCode
}
